import { NotificationContainer } from '@styles/ContainerStyles';
import { Button, Meta, theme } from 'aimo-ui';
import React from 'react';
import styled from 'styled-components/native';

const TextWrapper = styled.View`
  flex: 1 1 auto;
  margin-right: 10px;
`;

const ButtonWrapper = styled.View``;
export const NotificationGray = ({
  label,
  buttonText,
  action,
  text,
}: {
  label?: string;
  text?: string;
  buttonText?: string;
  action?: () => void;
}) => {
  return (
    <>
      {label && <Meta color={theme.colors.gray300}>{label}</Meta>}
      <NotificationContainer>
        <TextWrapper>
          <Meta>{text}</Meta>
        </TextWrapper>
        <ButtonWrapper>
          {action && buttonText && (
            <Button
              size="m"
              fullWidth={false}
              buttonType="primary"
              text={buttonText}
              onPress={action}
            />
          )}
        </ButtonWrapper>
      </NotificationContainer>
    </>
  );
};
